export default __webpack_public_path__ + "static/media/hermit_king.fdf3de6a.png";